export const treasury_legislation = [
  {
    id: 1,
    name: 'SAConstitution-web-eng',
    summary: 'shortsummary/SAConstitution-web-eng.html',
    link: 'SAConstitution-web-eng.pdf',
    audio_en: 'audio/en/SAConstitution-web-eng_en.mp3',
    audio_af: 'audio/af/SAConstitution-web-eng_af.mp3',
    audio_xh: 'audio/xh/SAConstitution-web-eng_xh.mp3'
  }
];